module.exports = __webpack_public_path__ + "img/line-social.de0a1299.svg";